module.exports = __webpack_public_path__ + "static/media/me.10773c16.svg";